import gsap from 'gsap';

let human = gsap.timeline({paused: true});
let elf = gsap.timeline({paused: true});
let darkelf = gsap.timeline({paused: true});
let oak = gsap.timeline({paused: true});
let dwarf = gsap.timeline({paused: true});
let kamael = gsap.timeline({paused: true});
let artea = gsap.timeline({paused: true});


const character = (tribe, gender, job)=>{
    switch (tribe) {
        case 0 :
            human.seek(0);
            human.play();
            break;
        case 1 :
            elf.seek(0);
            elf.play();
            break;
        case 2 :
            darkelf.seek(0);
            darkelf.play();
            break;
        case 3 :
            oak.seek(0);
            oak.play();
            break;
        case 4 :
            dwarf.seek(0);
            dwarf.play();
            break;
        case 5 :
            kamael.seek(0);
            kamael.play();
            break;
        case 6 :
            artea.seek(0);
            artea.play();
            break;
    }
};

(()=>{
    human
        .addLabel("human")
        .from('.sele-con__cht--human1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--human2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'human-=0.0');
    elf
        .addLabel("elf")
        .from('.sele-con__cht--elf1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--elf2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'elf-=0.0');
    darkelf
        .addLabel("darkelf")
        .from('.sele-con__cht--darkelf1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--darkelf2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'darkelf-=0.0');
    oak
        .addLabel("oak")
        .from('.sele-con__cht--oak1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--oak2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'oak-=0.0');
    dwarf
        .addLabel("dwarf")
        .from('.sele-con__cht--dwarf1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--dwarf2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'dwarf-=0.0');
    kamael
        .addLabel("kamael")
        .from('.sele-con__cht--kamael1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--kamael2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'kamael-=0.0');
    artea
        .addLabel("artea")
        .from('.sele-con__cht--artea1', 0.88, {x:180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, '+=0.2')
        .from('.sele-con__cht--artea2', 0.88, {x:-180, alpha:0, filter:"blur(4px)", ease: 'sine.easeIn'}, 'artea-=0.0');
})();

export default {
    character
};


// WEBPACK FOOTER //
// ./src/js/create/animation.js